import { useEffect } from 'react';

/**
 * Hook that closes every <details className="responsive-details"> element when the window width drops below the specified breakpoint (default 800px).
 * Optionally restores them when the width becomes larger (off by default).
 * @param breakpoint - Minimum width in pixels to keep them open (default 800)
 * @param restoreOnLarge - If true, re-opens details when width >= breakpoint (default false)
 */
export function useCloseResponsiveDetailsOnSmallScreen(
  breakpoint = 1200,
  restoreOnLarge = true
) {
  useEffect(() => {
    const updateResponsiveDetails = () => {
      const width = window.innerWidth;
      // Only select details that have the responsive-details
      const responsiveDetails = document.querySelectorAll(
        'details.responsive-details'
      );

      responsiveDetails.forEach((detailsEl) => {
        if (width < breakpoint) {
          if (detailsEl.open) {
            detailsEl.open = false;
          }
        } else if (restoreOnLarge) {
          if (!detailsEl.open) {
            detailsEl.open = true;
          }
        }
      });
    };

    // Initial check
    updateResponsiveDetails();

    // Listen for resize
    window.addEventListener('resize', updateResponsiveDetails);

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateResponsiveDetails);
    };
  }, [breakpoint, restoreOnLarge]);
}